<div class="header-icon">
  <a class="customer-logo-register" [routerLink]="{ cxRoute: '/' } | cxUrl">
    <app-custom-icons [type]="iconTypes.OHGAR_ICON"></app-custom-icons>
  </a>

  <a class="professional-logo-register" [routerLink]="{ cxRoute: 'ohbar' } | cxUrl">
    <img src="/images/LOGO-OHBAR.svg" alt="Ohbar Logo" />
  </a>
</div>
